import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import Product from './Product/Product';
import useStyles from './style'
import Progress from '../MySpinner2/MySpinner';
// import {FaSadCry} from 'react-icons/fa'
import { useLocation } from 'react-router-dom';
// import { LocalGasStation } from '@material-ui/icons';

const Products = ({ products, handleAdd, loading, state, setState }) => {
    const classes = useStyles();
    const location = useLocation();
    // console.log({ products });

    useEffect(() => {
        if(location.pathname === "/" && state){
            setState("");
        } else if(location.pathname === "/search/:name" && !state){
            // console.log('okeyyyyy');
            setState("zzzz");
        }
    }, [location.pathname])

    return (
        <main className={classes.content}>
            <div className={classes.toolbar}></div>
            {
                loading ? (
                    <Progress />
                ) : (
                    <Grid container justify="center" spacing={3}>
                        {
                            products ? (
                                products.map(item => {
                                    // const {name, media, description, price} = item;
                                    return (
                                        <Grid item key={item.id} xs={12} sm={6} md={4} lg={3}>
                                            <Product {...item} handleAdd={handleAdd} />
                                        </Grid>
                                    )
                                })
                            ) : (
                                <h2>Sorry No Products Match 🙃</h2>
                            )
                        }
                    </Grid>
                )
            }
        </main >
    )
}

export default Products
